import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  hiddenInput: {
    position: 'absolute',
    left: -9999,
    opacity: 0,
    pointerEvents: 'none',
  },
})

export default styles